import { Bounded, Bounds } from "./geometry.bounds";
import { IsBounds } from "./geometry.interfaces";
export class BoundedCollection extends Bounded {
    constructor() {
        super();
        this._items = new Array();
    }
    get data() {
        return this._items;
    }
    set data(d) {
        this._items = d;
        this.invalidateBounds();
    }
    get length() {
        return this._items.length;
    }
    push(...views) {
        this._items.push(...views);
        this.invalidateBounds();
    }
    pop() {
        const d = this._items.pop();
        if (d) {
            this.invalidateBounds();
        }
        return d;
    }
    findIndex(predicate, thisArg) {
        return this._items.findIndex(predicate, thisArg);
    }
    splice(start, deleteCount) {
        this._items.splice(start, deleteCount);
        this.invalidateBounds();
    }
    _buildBounds() {
        return Bounds.FromBounds(...this._items.map((v) => (IsBounds(v) ? v : v.boundingBox)));
    }
}
//# sourceMappingURL=geometry.bounds.collection.js.map